// De pinafsluiting bij de dagafsluiting: de bonrol van de pinautomaat (foto of pdf).
//
// Twee calls die de generieke Refine dataProvider niet kan maken: de upload is multipart, en de bytes
// terughalen moet met de bearer (die in het geheugen zit, niet in een cookie — een <img src> of een
// gewone link krijgt hem dus niet mee). Zelfde patroon als src/api/animalPhoto.ts.
import { getAccessToken } from "../auth";

const API_URL = (import.meta.env.VITE_API_URL as string | undefined) ?? "/api";

export interface PinBijlage {
  ref: string;
  naam: string | null;
  type: string | null;
  grootte: number | null;
}

function authHeaders(): Record<string, string> {
  const token = getAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** De bonrol uploaden. De ref die terugkomt gaat mee met het afsluiten of het concept. */
export async function uploadPinBijlage(file: File): Promise<PinBijlage> {
  const form = new FormData();
  form.append("file", file);
  const res = await fetch(`${API_URL}/dagafsluiting/pinbijlage`, {
    method: "POST",
    headers: authHeaders(), // geen Content-Type — de browser zet de multipart-boundary
    body: form,
  });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
  return (await res.json()) as PinBijlage;
}

/** De bijlage van een opgeslagen dag ophalen, als blob — voor de preview of de download. */
export async function fetchPinBijlageBlob(dag: string, vestigingId: number | null): Promise<Blob> {
  const query = `dag=${dag}${vestigingId != null ? `&vestigingId=${vestigingId}` : ""}`;
  const res = await fetch(`${API_URL}/dagafsluiting/pinbijlage/content?${query}`, {
    headers: authHeaders(),
  });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
  return res.blob();
}
